var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#timeline-check_svg__clip0_1_1999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.333 18.667H4.667v-14h4.666v14zM4.667 51.333h4.666v-14H4.667v14zm2.333-28A4.68 4.68 0 002.333 28c0 2.59 2.1 4.667 4.667 4.667A4.65 4.65 0 0011.667 28 4.665 4.665 0 007 23.333zM56 14v28a4.65 4.65 0 01-4.667 4.667h-28A4.665 4.665 0 0118.667 42v-9.333L14 28l4.667-4.667V14c0-2.59 2.1-4.667 4.666-4.667h28A4.65 4.65 0 0156 14zm-9.917 10.103l-2.706-3.29L35 29.167l-3.71-3.687-2.707 2.707 6.417 7 11.083-11.084z",
    fill: "#54DCF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "timeline-check_svg__clip0_1_1999"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
export default SvgTimelineCheck;